import { useCollectionLayout } from "./CollectionLayoutProvider.next";

export default function useSiteConfig() {
  return useCollectionLayout().siteConfig;
}
